import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import Inspection from 'src/models/helperTypes/Inspection';

export interface InspectionState {
  inspections: Inspection[];
}

export const initialState: InspectionState = {
  inspections: [],
};

const inspectionSlice = createSlice({
  name: 'inspection',
  initialState,
  reducers: {
    setInspections: (state, action: PayloadAction<Inspection[]>) => {
      state.inspections = action.payload;
    },
  },
});

export const { setInspections } = inspectionSlice.actions;
export default inspectionSlice.reducer;
